import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";

const ToolFavoritePathVarsSchema = z.object({
  id: z.string()
});

export const ZToolFavorites = {
  /**
   * POST /api/tools/:id/favorite
   * Mark a tool as a workspace favorite. Idempotent.
   */
  Favorite: {
    method: "POST" as const,
    path: "/api/tools/:id/favorite",
    PathVars: ToolFavoritePathVarsSchema,
    Response: ApiSuccessSchema(z.object({ success: z.literal(true) }))
  },

  /**
   * DELETE /api/tools/:id/favorite
   * Remove a tool from workspace favorites. Idempotent.
   */
  Unfavorite: {
    method: "DELETE" as const,
    path: "/api/tools/:id/favorite",
    PathVars: ToolFavoritePathVarsSchema,
    Response: ApiSuccessSchema(z.object({ success: z.literal(true) }))
  }
} as const;
